import {
    MockMap,
    SequentialMockAdapter,
} from '@ama-sdk/core';
import {
    getMockAdapter,
    getMockScenario,
} from '@refx/shared-common';
/*import {
  OPERATION_ADAPTER as SAFE_TRAVEL_OPERATION_ADAPTER,
} from '@safe-travel/sdk';*/
export declare type MockFunction = () => Promise<MockMap>;
// import { mockMaps } from '../../../e2e-playwright-customization/config/mock-map';

export const importMockMaps = async () => (await import('../../../e2e-playwright-customization/config/mock-map')).mockMaps;

/**
 * returns true iff the scenario is a path to a ALF logs file
 *
 * @param scenario scenario name provided as get/post parameter
 * @returns true iff the scenario is a path to a ALF logs file
 */
export function isAlfMockScenario(scenario?: string): boolean {
    return !!scenario && scenario.endsWith('.bin');
}

/**
 * Returns a SequentialMockAdapter which is checking the MockConfiguration.
 *
 * @param fallbackConfiguration if no MockConfiguration was found, return the fallbackConfiguration.
 */

export const mockAdapter: SequentialMockAdapter = getMockAdapter(
    async () => {
        const maps = await importMockMaps();
        return maps[getMockScenario() || 'flexPremiumOneWay1AdtMock'];
    }
);